import React from 'react'
import { useTranslation } from 'react-i18next'
import { enumValues } from 'cityads-v3/utils/arrayUtils'

import MenuItem from '@mui/material/MenuItem'

import TextField from 'cityads-v3/components/TextField/TextField'

import { LegalSubjectId } from 'cityads-v3/reducers/advertisingLawForm'

import { FormFields } from './AdvertisingMarkingForm.hooks'

type Step2Props = {
  lastName    : FormFields['lastName']
  firstName   : FormFields['firstName']
  middleName  : FormFields['middleName']
  legalSubject: FormFields['legalSubject']
}

const LEGAL_SUBJECT_TRANSLATION_KEYS = {
  [LegalSubjectId.legalEntity]: 'advertisingMarking.form.legal_entity',
  [LegalSubjectId.soleProprietor]: 'advertisingMarking.form.sole_proprietor',
  [LegalSubjectId.selfEmployed]: 'advertisingMarking.form.self_employed',
}

export default function Step2({ lastName, firstName, middleName, legalSubject }: Step2Props): JSX.Element {
  const { t } = useTranslation(['Publisher'])

  return (
    <>
      <TextField
        label      = {t('advertisingMarking.form.last_name')}
        helperText = {lastName.error}
        error      = {!!lastName.error}
        value      = {lastName.value || ''}
        onChange   = {lastName.handleChange}
        margin     = "normal"
        autoFocus
        fullWidth
        required
      />

      <TextField
        label      = {t('advertisingMarking.form.first_name')}
        helperText = {firstName.error}
        error      = {!!firstName.error}
        value      = {firstName.value || ''}
        onChange   = {firstName.handleChange}
        margin     = "normal"
        fullWidth
        required
      />

      <TextField
        label      = {t('advertisingMarking.form.middle_name')}
        helperText = {middleName.error}
        error      = {!!middleName.error}
        value      = {middleName.value || ''}
        onChange   = {middleName.handleChange}
        margin     = "normal"
        fullWidth
      />

      <TextField
        select
        label      = {t('advertisingMarking.form.legal_subject')}
        helperText = {legalSubject.error}
        error      = {!!legalSubject.error}
        value      = {legalSubject.value || ''}
        onChange   = {legalSubject.handleChange}
        margin     = "normal"
        fullWidth
        required
      >
        {enumValues(LegalSubjectId).map((id: LegalSubjectId) => (
          <MenuItem value={id} key={id}>{t(LEGAL_SUBJECT_TRANSLATION_KEYS[id])}</MenuItem>
        ))}
      </TextField>
    </>
  )
}
